import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import history from 'src/history'

// Utils
import {
  dispatchEvent,
  oneTimeTagEventDispatcher
} from 'src/helpers/tagManager'
import { OVERLAY_HELPERS } from 'src/constants/navigation'
import {
  ScrolledIntoView,
  EVENTS_LABELS,
  ViewShareFromBottomDigest
} from 'src/constants/trackingEvents'

// Components
import { Button, Panel, Text } from 'src/Components'
import BotHead from 'src/Components/shared/Avatar/BotHeadColored'

// Styles
import styles from './ShareCta.module.scss'

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.ReferralSection
})

const ShareCta = () => (
  <Panel className={styles.card}>
    <Text element='div' align='center'>
      <BotHead quizzical size='l' />
    </Text>
    <Panel.Heading>
      <FormattedMessage
        data-qa='share-homebot-bottom-digest-heading'
        id='Homeowner.shareForm.heading'
        defaultMessage='Know someone who could use a Homebot report for their home?'
      />
    </Panel.Heading>
    <div className={styles.btnWrapper}>
      <Button
        onClick={() => {
          dispatchEvent(ViewShareFromBottomDigest)
          history.push(OVERLAY_HELPERS.shareHomebot.buildPath())
        }}
      >
        <FormattedMessage
          data-qa='share-homebot-bottom-digest-button'
          id='Homeowner.shareSectionButton.cta'
          defaultMessage='Share Homebot'
        />
      </Button>
    </div>
    <Waypoint onEnter={scrollIntoView} bottomOffset='25%'>
      <div />
    </Waypoint>
  </Panel>
)

export default ShareCta
